
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WaypointAttributes } from '../../../typings/features/waypoint-attributes';
import { AbstractDetailComponent } from '../abstract-detail.component';
@Component({
  selector: 'jmkw-waypoint-detail',
  standalone: true,
  imports: [],
  templateUrl: './waypoint-detail.component.html',
  styleUrls: ['./waypoint-detail.component.scss', '../nav-widgets.shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaypointDetailComponent extends AbstractDetailComponent<WaypointAttributes> {
  @Input() attributes!: WaypointAttributes;
}
